import React from "react";
import { Route } from "react-router-dom";
import SellerHeaderContainer from "../../containers/shared/SellerHeaderContainer";
import SellerNavBarContainer from "../../containers/shared/SellerNavBarContainer";
import Meta from "../shared/atoms/Meta";

const SellerDashboardLayout = ({ children }) => (
  <div>
    <Meta title="SaRa Marketplace - Seller" />
    {children}
  </div>
);

const index = ({ component: Component, ...rest }) => {
  return (
    <React.Fragment>
      <Route
        {...rest}
        render={(matchProps) => (
          <SellerDashboardLayout>
            <SellerHeaderContainer />
            <div style={{ marginTop: "61px" }}>
              <SellerNavBarContainer />
              <Component {...matchProps} />
            </div>
          </SellerDashboardLayout>
        )}
      />
    </React.Fragment>
  );
};

export default index;
